var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DotLabel',{staticClass:"nixia-connection-status",attrs:{"title":_vm.connected ? 'Conectado' : 'Desconectado',"color":_vm.connected ? 'success' : 'danger',"size":"small"}})}
var staticRenderFns = []

export { render, staticRenderFns }